export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./galaxsys-frame.vue?vue&type=template&id=8ff2c1ec"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/galaxsys/galaxsys-frame.vue?vue&type=template&id=8ff2c1ec
// module id = BTdu
// module chunks = 0